import { NgModule } from '@angular/core';
import { ClientService } from './client/client.service';
import { ReactiveLogger } from './logging/logger.service';
import { PERMISSION_GUARDS } from './routing/permission-guards';

@NgModule({
  providers: [
    ReactiveLogger,
    ...PERMISSION_GUARDS,
    ClientService,
  ],
})
export class GlobalServicesModule {}



// WEBPACK FOOTER //
// ./src/app/services/global-services.module.ts